import { useQuery } from "@tanstack/react-query";
import {
  GetDailyForecastWeatherRequest,
  GetDailyForecastWeatherResponse
  //GetOneCallWeatherRequest,
  //GetOneCallWeatherResponse
} from "interfaces/Weather";
import { useMemo } from "react";
import { useLocation } from "react-router";
import { useApiClient } from "./ApiClientContext";
import { makeHooksForApiClient } from "./auto-api-hook-wrapper";

const DAILY_FORECAST_URL = `https://${
  process.env.API_BASE_HOSTNAME || "dev.1stbet.com"
}/v1/weather/forecast/daily`;
/*const ONECALL_WEATHER_URL = `https://${
  process.env.API_BASE_HOSTNAME || "dev.1stbet.com"
}/v1/weather/onecall`*/

export const useRacehorse360Api = () => {
  const {
    applicationFeatureFlagClient,
    facilityBlackoutClient,
    facilityClient,
    horseClient,
    horseExamClient,
    horseExamRequirementClient,
    notificationClient,
    raceConditionClient,
    raceClient,
    regionClient,
    rolePermissionClient,
    stallApplicationClient,
    trackOpticsVideoClient,
    trainerClient,
    upcomingRaceEntryClient,
    userClient,
    vaccinationClient,
    workOrderClient,
    workoutRequestClient,
    workoutClient,
    getAccessTokenSilently
  } = useApiClient();
  const location = useLocation();

  return useMemo(() => {
    /*const getOneCallWeather = async (
      key,
      request: GetOneCallWeatherRequest
    ): Promise<GetOneCallWeatherResponse> => {
      if (request.lat && request.lon) {
        const query = new URLSearchParams({
          lat: request.lat.toString(),
          lon: request.lon.toString(),
          units: request.units || "imperial",
          exclude: request.exclude || "current,minutely,hourly,alerts"
        })
        const token = await getAccessTokenSilently()
        return fetch(`${ONECALL_WEATHER_URL}?${query}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(res => res.json())
      }
    }*/
    const getDailyForecast = async ({
      queryKey,
      onSuccess,
      onError,
      enabled
    }: {
      queryKey: (string | GetDailyForecastWeatherRequest)[];
      onSuccess?: (data: GetDailyForecastWeatherResponse) => void;
      onError?: (error: any) => void;
      enabled?: boolean;
    }): Promise<GetDailyForecastWeatherResponse> => {
      try {
        const request: GetDailyForecastWeatherRequest =
          queryKey[1] as GetDailyForecastWeatherRequest;

        if (request.lat && request.lon) {
          const query = new URLSearchParams({
            lat: request.lat.toString(),
            lon: request.lon.toString(),
            units: request.units || "imperial",
            ...(request.cnt ? { cnt: request.cnt.toString() } : {})
          });

          const token = await getAccessTokenSilently();
          const data = fetch(`${DAILY_FORECAST_URL}?${query}`, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(res => res.json());

          if (onSuccess && enabled !== false) {
            onSuccess(data);
          }

          return data;
        }

        return null;
      } catch (error) {
        if (onError && enabled !== false) {
          onError(error);
        }
        throw error;
      }

      // Only used if we don't have a paid API token and need to retrieve forecast from "OneCall"
      // if (request.lon && request.lat) {
      //   const result = await getOneCallWeather(key, request)
      //   const { daily, lat, lon, timezone, timezone_offset } = result
      //   const response = {
      //     lat,
      //     lon,
      //     timezone,
      //     timezone_offset,
      //     list: daily
      //   }
      //   return response
      // }
    };

    return {
      ...makeHooksForApiClient(applicationFeatureFlagClient),
      ...makeHooksForApiClient(facilityClient),
      ...makeHooksForApiClient(facilityBlackoutClient),
      ...makeHooksForApiClient(horseClient),
      ...makeHooksForApiClient(horseExamClient),
      ...makeHooksForApiClient(horseExamRequirementClient),
      ...makeHooksForApiClient(notificationClient),
      ...makeHooksForApiClient(raceClient),
      ...makeHooksForApiClient(raceConditionClient),
      ...makeHooksForApiClient(regionClient),
      ...makeHooksForApiClient(rolePermissionClient),
      ...makeHooksForApiClient(stallApplicationClient),
      ...makeHooksForApiClient(trackOpticsVideoClient),
      ...makeHooksForApiClient(trainerClient),
      ...makeHooksForApiClient(upcomingRaceEntryClient),
      ...makeHooksForApiClient(userClient),
      ...makeHooksForApiClient(vaccinationClient),
      ...makeHooksForApiClient(workOrderClient),
      ...makeHooksForApiClient(workoutClient),
      ...makeHooksForApiClient(workoutRequestClient),
      useDailyForecast: (
        request: GetDailyForecastWeatherRequest,
        {
          enabled = true,
          onSuccess = (response: GetDailyForecastWeatherResponse) => {
            return;
          },
          onError = () => {
            return;
          }
        }
      ) =>
        useQuery({
          queryKey: ["dailyForecast", request],
          queryFn: ({ queryKey }) =>
            getDailyForecast({ queryKey, onSuccess, onError, enabled }),
          enabled
        })

      // no need for this but I put the code in if we wanted it
      // useOneCallWeather: (
      //   request: GetOneCallWeatherRequest,
      //   onSuccess = () => {}
      // ) =>
      //   useQuery(["oneCallWeather", request], getOneCallWeather, { onSuccess })
    };
  }, [
    applicationFeatureFlagClient,
    facilityClient,
    facilityBlackoutClient,
    horseClient,
    horseExamClient,
    horseExamRequirementClient,
    notificationClient,
    raceClient,
    raceConditionClient,
    regionClient,
    rolePermissionClient,
    trainerClient,
    userClient,
    vaccinationClient,
    stallApplicationClient,
    workOrderClient,
    workoutRequestClient,
    workoutClient,
    location.pathname
  ]);
};
